import { Breadcrumb } from '@aipb/gulliver/dynamic-gallery/model';
import { TruncatePipe } from '@aipb/shared/ui/pipes';

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'dg-breadcrumb-list',
  templateUrl: './breadcrumb-list.component.html',
  styleUrls: ['./breadcrumb-list.component.scss'],
  imports: [TruncatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class BreadcrumbListComponent {
  @Input() breadcrumbs: Breadcrumb[] = [];

  @Output() action = new EventEmitter<Breadcrumb>();

  dividerIcon = faChevronRight;
}
